import React from 'react';
import { navLinks, contactData } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5c5d669f-c9f8-4adb-8172-cba45a477e0a/artifacts/fku8950g_N%C3%A9vtelen%20terv%20%281%29.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 overflow-hidden"
      style={{ backgroundColor: '#080d1a' }}
    >
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-violet-600/10 blur-[140px] rounded-full pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
        <div className="grid md:grid-cols-12 gap-10">
          {/* Brand + tagline */}
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="Boldigital" className="h-12 w-auto object-contain mb-5" />
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
              Weboldal, webes applikáció és AI-megoldások vállalkozásoknak – egyedi fejlesztés, automatizálás és skálázhatóság egy kézből.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">Oldalak</div>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    data-testid={`footer-nav-${link.id}`}
                    className="text-slate-300 hover:text-white transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-4">Kapcsolat</div>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`mailto:${contactData.email}`}
                  className="group inline-flex items-center gap-1.5 text-slate-200 hover:text-white transition-colors"
                  data-testid="footer-email-link"
                >
                  {contactData.email}
                  <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contactData.phone.replace(/\s/g, '')}`}
                  className="text-slate-300 hover:text-white transition-colors"
                  data-testid="footer-phone-link"
                >
                  {contactData.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            © {currentYear} Boldigital. Minden jog fenntartva.
          </p>
          <p className="text-slate-600 text-xs">
            Konverzióra tervezve · Magyarországon készült
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
